export enum DocumentVisibilitySettingEnum {
    SIGNATURE_CIRCULAR = '2216e76f-bba8-4dec-9d67-642381a34263',
    CURRENT_CARD_FORM = '40e75fd0-28b0-40b6-902d-0868b0d363e0',
    TAX_BOARD = 'adb9b1b1-a97f-44f1-ad4e-c81e6c118392'
}
